@if (fund.urlImage && fund.urlImage?.value !== '') {
  <img
    class="object-cover rounded-full ring-bg-card flex-0 ring ring-offset-1 ring-offset-transparent"
    [ngStyle]="{ height: size, width: size }"
    [src]="fund.urlImage.value"
    [alt]="fund.title"
  />
} @else if (fund.iconClass && fund.iconClass?.value !== '') {
  <div
    class="flex items-center justify-center object-cover rounded-full bg-primary-50 text-primary-700 dark:bg-primary dark:text-on-primary ring-bg-card flex-0 ring ring-offset-1 ring-offset-transparent"
    [ngStyle]="{ height: size, width: size }"
  >
    <mat-icon class="text-current" [svgIcon]="fund.iconClass.value"></mat-icon>
  </div>
} @else if (showDefaultIcon) {
  <div
    class="flex items-center justify-center object-cover rounded-full bg-primary-50 text-primary-700 dark:bg-primary dark:text-on-primary ring-bg-card flex-0 ring ring-offset-1 ring-offset-transparent"
    [ngStyle]="{ height: size, width: size }"
  >
    <mat-icon class="text-current icon-size-5" [svgIcon]="getRandomIconName(index)"></mat-icon>
  </div>
}
